// extracted by mini-css-extract-plugin
export default {"paper_container":"Categories_paper_container__1ZuDL","header_title":"Categories_header_title__KbEIV","search_add_container":"Categories_search_add_container__F38e+"};